var map = {
	"./alert.svg": "659f",
	"./arrow-down.svg": "c874",
	"./arrow-left.svg": "ac3b",
	"./arrow-right.svg": "cd8c",
	"./catalog.svg": "928d",
	"./close.svg": "8b1b",
	"./confirm-rounded.svg": "697a",
	"./copy.svg": "8aac",
	"./edit.svg": "daf0",
	"./eye.svg": "7364",
	"./file.svg": "a147",
	"./gallery.svg": "6ec0",
	"./globe.svg": "0de3",
	"./helpcenter.svg": "6cf0",
	"./learn.svg": "2d29",
	"./logo_sl.svg": "24e5",
	"./logout.svg": "69e3",
	"./menu.svg": "d17f",
	"./move.svg": "d8c1",
	"./play-circle.svg": "1708",
	"./plus-square.svg": "0156",
	"./plus.svg": "eb38",
	"./search.svg": "d103",
	"./select-and-learn.svg": "6487",
	"./settings.svg": "9174",
	"./shopping-bag.svg": "38f3",
	"./thumbs-up.svg": "fe9c",
	"./trash.svg": "af22",
	"./upload.svg": "5a96",
	"./user.svg": "6aed",
	"./zoom-in.svg": "d3ec",
	"./zoom-out.svg": "3063"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";